module.exports = __webpack_public_path__ + "07e2de1d74f8f97e7b7ff32b827c09c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/img2_0.jpg
// module id = 539
// module chunks = 0